import { cn } from '@/lib/cn';
import type { ModelName } from '@pigello/pigello-matrix';
import { Icons } from '../icons';

import type { JSX } from "react";

export const getTabIcon = (
  modelName: ModelName,
  className?: string
): JSX.Element | null => {
  const iconClass = cn('size-4 min-h-[16px] min-w-[16px]', className);

  const icons: Partial<Record<ModelName, JSX.Element>> = {
    tenant: <Icons.tenant className={iconClass} />,
    building: <Icons.building className={iconClass} />,
    realestate: <Icons.realestate className={iconClass} />,
    apartment: <Icons.apartment className={iconClass} />,
    parkingspot: <Icons.parkingspot className={iconClass} />,
    parkinglot: <Icons.parkinglot className={iconClass} />,
    outdoorsection: <Icons.outdoorsection className={iconClass} />,
    outdoorarea: <Icons.outdoorarea className={iconClass} />,
    company: <Icons.company className={iconClass} />,
    region: <Icons.region className={iconClass} />,
    commonarea: <Icons.commonarea className={iconClass} />,
    industrialpremises: <Icons.industrialpremises className={iconClass} />,
    apartmentcontract: <Icons.apartmentcontract className={iconClass} />,
    industrialpremisescontract: (
      <Icons.industrialpremisescontract className={iconClass} />
    ),
    outdoorsectioncontract: (
      <Icons.outdoorsectioncontract className={iconClass} />
    ),
    parkingspotcontract: <Icons.parkingspotcontract className={iconClass} />,
    othercontract: <Icons.othercontract className={iconClass} />,
    blockcontract: <Icons.blockcontract className={iconClass} />,
    organizationuser: <Icons.organizationuser className={iconClass} />,
    signabledocument: <Icons.signabledocument className={iconClass} />,
    invoice: <Icons.invoice className={iconClass} />,
    invoicepayment: <Icons.invoicepayment className={iconClass} />,
    monitoringconfiguration: (
      <Icons.monitoringconfiguration className={iconClass} />
    ),
    sensor: <Icons.sensor className={iconClass} />,
    brfapartment: <Icons.brfapartment className={iconClass} />,
    automaticdistributionquota: (
      <Icons.automaticdistributionquota className={iconClass} />
    ),
    notification: <Icons.notification className={iconClass} />,
    measurementseries: <Icons.measurementseries className={iconClass} />,
    verificationgroup: <Icons.verificationgroup className={iconClass} />,
    verification: <Icons.verification className={iconClass} />,
    generalerrand: <Icons.errand className={iconClass} />,
    inspectionerrand: <Icons.inspections className={iconClass} />,
  };

  return icons[modelName] ?? null;
};
